export default __webpack_public_path__ + "static/media/MKTG-10901-YBYL-QRActivationDisplayBanner.cc15e1a0.jpg";